import { PropsWithChildren } from "react";
import styles from "./Authenticated.module.scss";

const AuthenticatedLayout = ({ children }: PropsWithChildren<unknown>) => (
  <div className={styles.layout}>{children}</div>
);

export default AuthenticatedLayout;
